import { getChannel } from '../../services/api/channel.api';
import { GET_CHANNEL_SINGLE_REQUEST, GET_CHANNEL_SINGLE_SUCCESS, GET_CHANNEL_SINGLE_FAILURE } from '../types';
import { transformChannel } from '../../transforms/channel';
import { transformError } from '../../transforms/error';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
		data: transformChannel({}),
	},

	mutations: {
		[GET_CHANNEL_SINGLE_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
			state.data = {};
		},
		[GET_CHANNEL_SINGLE_SUCCESS](state, data) {
			state.isLoading = false;
			state.data = transformChannel(data);
		},
		[GET_CHANNEL_SINGLE_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async getChannel({ commit }, id) {
			try {
				commit(GET_CHANNEL_SINGLE_REQUEST);
				const { data } = await getChannel(id);
				commit(GET_CHANNEL_SINGLE_SUCCESS, data);
			} catch (error) {
				commit(GET_CHANNEL_SINGLE_FAILURE, error);
			}
		},
	},
};